document.addEventListener('DOMContentLoaded', () => {
  const playIcon =
    '<svg role="img" aria-label="Play video" aria-labelledby="play-video-title" class="icon" aria-hidden="true" data-prefix="fal" data-icon="play-circle" viewBox="0 0 512 512"><title id="play-video-title">Play Video</title><path fill="currentColor" d="M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm331.7-18l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM192 335.8V176.9c0-4.7 5.1-7.6 9.1-5.1l134.5 81.7c3.9 2.4 3.8 8.1-.1 10.3L201 341c-4 2.3-9-.6-9-5.2z"></path></svg>';

  document.querySelectorAll('.sun-protection-fabric').forEach((section) => {
    const toggleBtn = section.querySelector('.icon-videoplays');
    if (!toggleBtn) return;

    const pauseIcon = toggleBtn.innerHTML;

    const getVideo = () => {
      const isDesktop = window.innerWidth >= 591;
      return (
        (isDesktop
          ? section.querySelector('video.pc-video')
          : section.querySelector('video.mb-video')) || section.querySelector('video')
      );
    };

    const video = getVideo();
    if (video) {
      const videoTimer = setTimeout(() => {
        video.play().then(() => clearTimeout(videoTimer)).catch(() => {});
      }, 1000);
    }

    const onToggle = () => {
      const currentVideo = getVideo();
      if (!currentVideo) return;

      if (currentVideo.paused) {
        currentVideo.play();
        toggleBtn.innerHTML = pauseIcon;
      } else {
        currentVideo.pause();
        toggleBtn.innerHTML = `${playIcon}<span class="sr-only">Video play</span>`;
      }
    };

    toggleBtn.addEventListener('click', onToggle);
    toggleBtn.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onToggle();
      }
    });
  });
});
